import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

/**
 * Properties expected by the storage empty modal component
 */
export interface IStorageEmptyModalProps {
    onLoadTestData: () => void
    onStartFresh: () => void
}

/**
 * Displays user with a choice of either loading test data or starting fresh
 * @param {IStorageEmptyModalProps} props Props required by the component
 */
function StorageEmptyModalComponent(props: IStorageEmptyModalProps) {
    return (
        <Modal show={true}>
            <Modal.Header>
                <Modal.Title>Welcome!</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Thank you for visiting my React Kanban demonstration
                    project. Would you like to load my evaluation data or would
                    you prefer to start fresh?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={props.onLoadTestData}>
                    Load Evaluation Data
                </Button>
                <Button variant="secondary" onClick={props.onStartFresh}>
                    Start Fresh
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default StorageEmptyModalComponent
